<template>
    <div>
        <v-container >
            <div v-show="$route.path == '/'">
                <h1 style="text-align:center">Välkommen till Tid.nu!</h1>
                <p>
                    Här kan du enkelt synka tidpunkter för möten. Börja med att
                    ange mötesdetaljerna nedan. Därefter lägger du till
                    tidsförslag som du slutligen delar med dina vänner. När alla
                    svarat är det enkelt att se vilket tidsförslag som flest kan
                    delta på. Då är det bara att boka in mötet! För dig som
                    tidigare provat Doodle så kommer du märka att detta är ett
                    svenskt alternativ (utan för mycket reklam eller dyra
                    betalversioner).
                </p>
            </div>
            <h4 style="text-align:center">Planera in ett möte</h4>
            <v-form ref="form" lazy-validation>
                <v-text-field
                    v-model="title"
                    :rules="titleRules"
                    label="Rubrik"
                    required
                    class="inputField"
                ></v-text-field>

                <v-textarea
                    v-model="description"
                    label="Beskrivning (Frivilligt)"
                    required
                    class="inputField"
                ></v-textarea>

                <v-text-field
                    v-model="location"
                    label="Plats (Frivilligt)"
                    required
                    class="inputField"
                    style="color:black important"
                ></v-text-field>

                <h3 style="text-weight:bold;color:black;">Tema</h3>
                <div>
                    <v-radio-group
                        class="inputField"
                        true-value="0 "
                        v-model="theme"
                    >
                        <v-row hide-details>
                            <v-col hide-details>
                                <v-radio
                                    label="Möte"
                                    color="primary"
                                    :value="0"
                                />
                                <v-radio
                                    label="Date"
                                    color="primary"
                                    :value="1"
                                />
                                <v-radio
                                    label="Jobbmöte"
                                    color="primary"
                                    :value="2"
                                />
                            </v-col>
                            <v-col hide-details>
                                <v-radio
                                    label="Svensexa"
                                    color="primary"
                                    :value="3"
                                />
                                <v-radio
                                    label="Möhippa"
                                    color="primary"
                                    :value="4"
                                />

                                <v-radio
                                    label="Middag"
                                    color="primary"
                                    :value="5"
                                />
                            </v-col>
                            <v-col hide-details>
                                <v-radio
                                    label="Resa"
                                    color="primary"
                                    :value="6"
                                />
                                <v-radio
                                    label="Fest"
                                    color="primary"
                                    :value="7"
                                />
                                <v-radio
                                    label="Födelsedag"
                                    color="primary"
                                    :value="8"
                                />
                            </v-col>
                            <v-col hide-details>
                                <v-radio
                                    label="Kalas"
                                    color="primary"
                                    :value="9"
                                />
                                <v-radio
                                    label="Studentskiva"
                                    color="primary"
                                    :value="10"
                                />
                                <v-radio
                                    label="Övrigt"
                                    color="primary"
                                    :value="11"
                                />
                            </v-col>
                        </v-row>
                    </v-radio-group>
                    <v-text-field
                        v-show="theme == 11"
                        label="Övrigt Tema"
                        v-model="customtheme"
                    />
                </div>
            </v-form>

            <div v-show="!store.state.isLoggedIn">
                <schedulelogin ref="reg" />
                <!--<v-btn @click="register = !register">{{
                register ? "Logga in" : "Registrera"
            }}</v-btn>
            <v-container v-if="register">
                <Register ref="reg" v-bind:createmeeting="true" />
            </v-container>
            <v-container v-else>
                <Login ref="log" v-bind:createmeeting="true" />
            </v-container>-->
            </div>
            <v-btn
                style="background-color:#ffa500"
                class="mr-4"
                @click="Continue"
            >
                Nästa
                <v-icon style="font-size:15px;margin-left:5px"
                    >fas fa-arrow-right</v-icon
                >
            </v-btn>
        </v-container>
    </div>
</template>

<script>
import store from "../../../store";
//import Login from "../../auth/Login";
//i/mport Register from "../../auth/Register";
import schedulelogin from "../../auth/schedulelogin";
export default {
    created: function() {
        this.isLoggedIn = this.store.state.isLoggedIn;
    },
    components: {
        schedulelogin
    },
    data: () => ({
        name: "Createmeeting",
        register: true,
        isLoggedIn: null,
        store: store,
        location: "",
        title: store.state.schedule.title,
        titleRules: [
            v => !!v || "Rubrik krävs",
            v => (v && v.length <= 100) || "Rubrik måste vara 100 tecken lång"
        ],
        description: store.state.schedule.description,
        descRules: [v => !!v || "Beskrivning krävs"],
        theme: 0,
        username: store.state.schedule.username,
        themes: [
            "Möte",
            "Övrigt",
            "Jobbmöte",
            "Svensexa",
            "Möhippa",
            "Middag",
            "Resa",
            "Fest",
            "Födelsedag",
            "Kalas",
            "Studentskiva",
            "Date"
        ],
        customtheme: ""
    }),
    methods: {
        Continue: async function() {
            if (this.$refs.form.validate()) {
                if (!this.store.state.isLoggedIn && this.register) {
                    await this.$refs.reg.done();
                }
                if (this.store.state.isLoggedIn) {
                    let config = {
                        title: this.title,
                        description: this.description,
                        location: this.location,
                        theme: this.theme,
                        customtheme: this.customtheme
                    };

                    await this.store.dispatch("step1", config);
                    this.store.state.e1++;
                }
            }
            //this.store.state.showAlert = true;
            //this.store.state.alertMsg = "Logga in för att fortsätta";
            //this.store.state.alertType = "error";
            //}
        }
    }
};
</script>
<style scoped>
.inputField {
    color: black important;
    border-color: black important;
}
</style>
